<ag-grid-angular
  class="ag-theme-alpine"
  [serverSideFilterOnServer]="true"
  [serverSideInfiniteScroll]="true"
  [pagination]="true"
  [getContextMenuItems]="getContextMenuItems"
  [paginationPageSize]="paginationPageSize"
  [cacheBlockSize]="cacheBlockSize"
  [maxBlocksInCache]="maxBlocksInCache"
  [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
  [overlayLoadingTemplate]="overlayLoadingTemplate"
  [rowModelType]="rowModelType"
  [defaultColDef]="defaultColDef"
  [rowClassRules]="rowClassRules"
  [columnDefs]="columnDefs"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [rowData]="rowData$ | async"
  [suppressCopyRowsToClipboard]="true"
  [suppressRowClickSelection]="false"
  [sideBar]="sideBar"
  [animateRows]="true"
  [rowSelection]="rowSelection"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged()"
  (filterChanged)="filterChanged($event)"
  (columnMoved)="columnEverythingChanged($event)"
  (columnResized)="columnEverythingChanged($event)"
  (columnPinned)="columnEverythingChanged($event)"
  (columnVisible)="columnEverythingChanged($event)"
></ag-grid-angular>
<!--[rowGroupPanelShow]="'always'"-->
